var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPolygon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 132 86",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 46.583,
    cy: 43.013,
    fill: "url(#b)",
    rx: 43.583,
    ry: 42.835
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A77BFF",
    fillRule: "evenodd",
    d: "M25.23 80.364C15.333 72.512 9 60.489 9 47.013 9 23.356 28.513 4.178 52.583 4.178c7.758 0 15.042 1.992 21.352 5.484C66.456 3.73 56.942.178 46.583.178 22.513.178 3 19.356 3 43.013c0 16.033 8.962 30.008 22.23 37.35Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M59.345 36.014c-.878-.498-2.006-.498-3.008 0l-7.019 4.113-4.762 2.617-6.893 4.113c-.877.499-2.005.499-3.008 0l-5.389-3.24A3.035 3.035 0 0 1 27.762 41v-6.232c0-.997.502-1.994 1.504-2.617l5.39-3.116c.877-.498 2.005-.498 3.007 0l5.39 3.24a3.035 3.035 0 0 1 1.503 2.618v4.113l4.763-2.742v-4.238c0-.997-.502-1.994-1.504-2.617l-10.026-5.857c-.878-.499-2.006-.499-3.008 0l-10.277 5.982C23.5 30.032 23 31.029 23 32.026v11.715c0 .998.501 1.995 1.504 2.618l10.151 5.857c.878.499 2.006.499 3.008 0l6.893-3.988 4.763-2.742 6.892-3.988c.878-.498 2.006-.498 3.008 0l5.39 3.116a3.035 3.035 0 0 1 1.503 2.617v6.232c0 .997-.501 1.994-1.504 2.617l-5.263 3.116c-.878.498-2.006.498-3.008 0l-5.39-3.116a3.035 3.035 0 0 1-1.503-2.617v-3.989l-4.763 2.742v4.113c0 .997.502 1.994 1.504 2.617l10.152 5.858c.877.498 2.005.498 3.008 0l10.151-5.858A3.035 3.035 0 0 0 71 56.33V44.49c0-.997-.501-1.994-1.504-2.617l-10.151-5.858Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M-11.106 45.566c3.583-4.038 8.852-8.17 15.18-12.046.16-.697.338-1.389.533-2.073-6.984 4.145-12.871 8.656-16.835 13.123-3.5 3.945-5.608 7.984-5.457 11.763.466-.263.969-.47 1.498-.612.086-3.063 1.85-6.514 5.081-10.155Zm2.194 19.756c-.262.44-.574.846-.93 1.21.1.051.199.102.299.151 4.077 2.027 9.5 3.348 15.862 3.957 12.729 1.22 29.378-.393 46.945-5.1 17.568-4.708 32.793-11.635 43.207-19.056 5.204-3.708 9.241-7.564 11.758-11.358 2.517-3.793 3.564-7.605 2.613-11.155-1.203-4.49-5.619-7.725-11.792-9.794-6.126-2.053-14.183-3.032-23.191-2.896.541.483 1.07.979 1.587 1.487 8.262-.004 15.564.967 21.128 2.831 6.031 2.022 9.817 5.02 10.819 8.76.8 2.985-.032 6.35-2.413 9.938-2.381 3.587-6.261 7.318-11.38 10.966-10.233 7.292-25.283 14.154-42.724 18.828-17.44 4.673-33.905 6.255-46.414 5.056-6.257-.6-11.483-1.89-15.338-3.807l-.036-.018Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB634",
    d: "m105.5.5 1.485 4.014L111 6l-4.015 1.486L105.5 11.5l-1.485-4.014L100 6l4.015-1.486L105.5.5ZM98 21.5l1.08 2.92L102 25.5l-2.92 1.08L98 29.5l-1.08-2.92L94 25.5l2.92-1.08L98 21.5Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(53.114 -11.51 40.76) scale(71.3316 61.9782)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.578,
    stopColor: "#8452EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6838CA"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .5h132v85H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygon);
export default __webpack_public_path__ + "static/media/polygon.158b78ee.svg";
export { ForwardRef as ReactComponent };